import Head from "next/head";

import ContactSalesMain from "@/components/contact/contact-sales-main";
import SeoMetaData from "@/components/utils/seo-metadata";
import seoData from "@/data/seo/page-data.json";

export default function Sales() {
  return (
    <>
      <Head>
        <title>{seoData.CONTACT_SALES.title}</title>
        <SeoMetaData data={seoData.CONTACT_SALES} />
      </Head>

      <ContactSalesMain />
    </>
  );
}
